module.exports = __webpack_public_path__ + "img/积分.1ca3db2e.png";